import { FC } from "react";
import { useTranslation } from "react-i18next";

import { colors } from "config/constants";

import DangerIcon from "components/Icons/DangerIcon";
import Button from "components/Buttons/Button";
import ConfirmModal from "components/ConfirmModal";

export type DeleteModalComponentType = {
  visible:boolean;
  handleClick:() => void;
  fetching?:boolean;
  close?: () => void;
  title:string;
  buttonTitle:string;
  description:string;
  danger?:boolean;
  fill?:string;
}
const ConfirmModalComponent:FC<DeleteModalComponentType> = ({
  visible,
  handleClick,
  fetching,
  close,
  title,
  danger=false,
  description,
  fill,
  buttonTitle }) => {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      icon={<DangerIcon fill={fill || colors.red6}/>}
      title={title}
      text={description}
      visible={visible}
      onCancel={close}
      onOk={handleClick}
      width={416}
      btns={
        <>
          <Button
            title={t("action.cancel")}
            transparent={true}
            onClick={close}
            disabled={fetching}
          />
          <Button title={buttonTitle} danger={danger} onClick={handleClick} disabled={fetching} />
        </>
      }
    />
  );
};
export default ConfirmModalComponent;